import { useState } from "react";
import {
  CardHeader,
  CardActions,
  CardContent,
  Dialog,
  Button,
  Grid,
  TextField,
  DataGrid,
  IconButton,
  Typography,
} from "../../../../../components";
import { NfSaidaService, notification } from "../../../../../services";
import { formatDate, responseErros } from "../../../../../utils";
import { format } from "date-fns";

const CartaCorrecaoDialog = ({
  openCartaCorrecaoDialog,
  setOpenCartaCorrecaoDialog,
  id,
  setLoading,
  nfSaida,
  setNfSaida,
  nfSaidaEntity,
}) => {
  const [correcao, setCorrecao] = useState("");
  const nfSaidaService = new NfSaidaService();
  const colunas = [
    { field: "numeroSequencial", headerName: "Nº", flex: 100 },
    { field: "status", headerName: "Status", flex: 200 },
    { field: "motivo", headerName: "Motivo", flex: 500 },
    { field: "protocolo", headerName: "Protocolo", flex: 350 },
    {
      field: "createdAt",
      headerName: "Data Criação",
      valueGetter: (params) =>
        format(formatDate.received(params.value), "dd/MM/yyyy"),
      flex: 250,
    },
    {
      headerName: "Ações",
      sortable: false,
      align: "center",
      headerAlign: "center",
      disableClickEventBubbling: true,
      renderCell: (params) => {
        return (
          <IconButton
            onClick={async () => {
              await buscarCartaCorrecao(params.id);
            }}
          >
            <i className="ph-fill ph-printer" style={{ fontSize: 18 }}></i>
          </IconButton>
        );
      },
    },
  ];

  const onChageCorrecao = (value) => {
    setCorrecao(value);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    enviarCartaCorrecao();
  };

  const enviarCartaCorrecao = async () => {
    const numeroSequencial = (nfSaida?.nfSaidaCartasCorrecao?.length ?? 0) + 1;
    const body = {
      correcao,
      numeroSequencial,
    };
    if (correcao?.length <= 14) {
      return notification.alertaGenericos("Quantidade mínima de 15 caracteres");
    }
    setLoading(true);
    const response = await nfSaidaService.cartaCorrecao(id, body);
    setLoading(false);
    if (!response.isAxiosError) {
      notification.cadastroSucesso();
      setCorrecao("");
      const cartaCorrecao = {
        ...response.data,
        numeroSequencial,
      };
      nfSaidaEntity.setCartasCorrecao([
        cartaCorrecao,
        ...(nfSaida?.nfSaidaCartasCorrecao || []),
      ]);
      setNfSaida(nfSaidaEntity);
      setOpenCartaCorrecaoDialog(false);
      await buscarCartaCorrecao(response.data.id);
    } else {
      responseErros(response);
    }
  };

  async function buscarCartaCorrecao(id) {
    setLoading(true);
    const result = await nfSaidaService.getCartaCorrecao(id);
    setLoading(false);
    if (!result.isAxiosError) {
      openAbaDanfeBase64(result.data);
    } else {
      responseErros(result);
    }
  }

  async function openAbaDanfeBase64(base64Pdf) {
    try {
      const response = await fetch(`data:application/pdf;base64,${base64Pdf}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site",
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  return (
    <>
      <Dialog
        fullWidth
        maxWidth="md"
        open={openCartaCorrecaoDialog}
        onClose={() => {
          setOpenCartaCorrecaoDialog(!openCartaCorrecaoDialog);
        }}
      >
        <CardHeader title="CARTA DE CORREÇÃO" />
        <form onSubmit={(event) => onSubmit(event)}>
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="correcao"
                  name="correcao"
                  label="Correção"
                  variant="outlined"
                  margin="normal"
                  onChange={(event) => onChageCorrecao(event.target.value)}
                  value={correcao}
                  required
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} className="d-flex justify-content-between">
                <Typography style={{ color: "#DC3545" }}>
                  Quantidade mínima de 15 caracteres
                </Typography>
                <Typography>
                  N° de caracteres: {correcao?.length || 0}
                </Typography>
              </Grid>
              <Grid item xs={12} className="mt-4">
                <DataGrid
                  rows={nfSaida?.nfSaidaCartasCorrecao || []}
                  columns={colunas}
                  rowCount={nfSaida?.nfSaidaCartasCorrecao?.length || 0}
                  disableAcoes
                />
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button variant="contained" color="primary" type="submit">
              <i
                className="ph-fill ph-check-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              SALVAR
            </Button>
            <Button
              variant="contained"
              color="padrao"
              onClick={() => setOpenCartaCorrecaoDialog(false)}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Fechar
            </Button>
          </CardActions>
        </form>
      </Dialog>
    </>
  );
};

export default CartaCorrecaoDialog;
